import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateLeadsViews } from '../../../lib/query/invalidateResource';
import { createLead } from '../api/leads';
import type { LeadFormValues } from '../types';
import { notification } from 'antd';

export function useCreateLead(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: LeadFormValues) => createLead(data),
    onSuccess: () => {
      notification.success({ message: 'Lead created successfully' });
      invalidateLeadsViews(queryClient);
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error: Error) => {
      const msg = (error as any)?.response?.data?.detail
        ?? (error as any)?.response?.data?.title
        ?? error.message
        ?? 'Failed to create lead';
      notification.error({ message: msg });
    },
  });
}
